module.exports = __webpack_public_path__ + "static/media/grid-item-b5.7beb9848.png";